import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChainLink1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChainLink1"><Path d="M13.5 17.5L9.5 21.5L2.5 14.5L6.5 10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 6.5L14.5 2.5L21.5 9.5L17.5 13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9 15L15 9" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChainLink1;
